export default "__VITE_ASSET__DzrfYBYl__"